module.exports = __webpack_public_path__ + "img/hr-solutions-logo-color.e35c9f2b.jpg";